import React, { useState, useEffect } from "react";
import { firestore } from "../../../components/firebase/FirebaseProvider";
import { useData } from "../../../components/firebase/DataProvider";
import {
  arrayToCurrencyString,
  arrayToCurrencyStringPromo,
  arrayToCurrencyStringKomisi,
  calculateHargaLevel,
} from "../../../utils/currency";
import { findOnePromo } from "../../../utils/promo";
import { analytics } from "../../../components/firebase/FirebaseProvider";
import { useHistory } from "react-router-dom";
import slugify from "slugify";
import Paper from "@material-ui/core/Paper";
import useStyles from "./style/flashSaleStyle";
import ScrollContainer from "react-indiana-drag-scroll";
// import useCountDownTimer from "../../../components/useCountDownTimer";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import Button from "@material-ui/core/Button";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import DialogFlashsale from "./dialogFlashsale";
import SpesialOfferIcon from "../../../assets/icon/spesial-offer.svg";
import FlashSaleIcon from "../../../assets/icon/flashSaleIcon.svg";

import {
  Card,
  Typography,
  CardActionArea,
  useMediaQuery,
  useTheme,
  Divider,
} from "@material-ui/core";
import Countdown from "react-countdown";
import { upperFirst } from "lodash";

// function Timer({ expiration_date }) {
//   const { timerArray } = useCountDownTimer(expiration_date);
//   // console.log(timerArray);
//   return (
//     <div style={{ display: "flex" }}>
//       <Typography>{timerArray[0]}</Typography>
//       <Typography>:</Typography>
//       <Typography>{timerArray[1]}</Typography>
//       <Typography>:</Typography>
//       <Typography>{timerArray[2]}</Typography>
//     </div>
//   );
// }

function FlashSale({ openFlashSale, setOpenFlashSale }) {
  const classes = useStyles();
  const history = useHistory();
  const [products, setProducts] = useState([]);
  // const [slicedProducts, setSlicedProducts] = useState([]);
  const [expiration_date, setExpire] = useState();
  const [keywords, setKeywords] = useState([]);
  // const { seconds } = useCountDownTimer(expiration_date);
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState();
  // const [open, setOpen] = useState(false);

  const { level, promo, global_komisi } = useData();

  const theme = useTheme();

  const miniScreen = useMediaQuery(theme.breakpoints.down("960"));

  useEffect(() => {
    async function getProducts() {
      setLoading(true);
      try {
        const flashsaleRef = promo?.filter((doc) => doc?.flash_sale === true);
        const spesialOfferRef = promo?.filter(
          (doc) => doc?.special_offer === true
        );

        const dataPromoRef =
          flashsaleRef?.length > 0
            ? flashsaleRef
            : spesialOfferRef?.length > 0
            ? spesialOfferRef
            : [];

        if (dataPromoRef?.length) {
          let expire = dataPromoRef?.[0]?.end_at?.toMillis();
          setExpire(expire);
          setMode(
            dataPromoRef?.[0]?.flash_sale
              ? "Flashsale"
              : dataPromoRef?.[0]?.special_offer
              ? "Special Offers"
              : ""
          );

          let allProducts = [];

          dataPromoRef.forEach(
            (doc) => (allProducts = allProducts?.concat(doc?.products))
          );

          const data = await Promise.all(
            allProducts?.map(async (product) => {
              const variants = await firestore
                .collection(`products/${product.id}/variants`)
                .get();
              return {
                id: product.id,
                ...product,
                variants: variants.docs.map((variant) => {
                  return {
                    id: variant.id,
                    ...variant.data(),
                  };
                }),
              };
            })
          );

          const dataKeywords = { "Semua Produk": "all" };

          data.forEach((el) => {
            if (!dataKeywords.hasOwnProperty(el?.kategori1?.nama)) {
              dataKeywords[el?.kategori1?.nama] = el?.kategori1?.id;
            }
          });

          setKeywords(Object.entries(dataKeywords));

          // setSlicedProducts(data?.slice(0, 5) ?? []);
          setProducts(data || []);
          setLoading(false);
        } else {
          // setSlicedProducts([]);
          setProducts([]);
        }
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    }
    getProducts();
  }, [promo]);

  const toDetailProduct = (id, title) => () => {
    // console.log("to detail...");
    analytics.logEvent("view_product", { name: title, id: id });

    history.push(`/produk/${slugify(title.toLowerCase())}/${id}`);
  };

  function populateProducts(P) {
    return P?.map((product) => {
      const productValue =
        product?.product_value !== undefined &&
        product?.product_value !== "" &&
        !Number.isNaN(product?.product_value) &&
        product?.product_value >= 0
          ? product?.product_value
          : 1;

      const price = product?.variants?.map((variant) =>
        calculateHargaLevel(
          variant?.harga_normal,
          global_komisi,
          level?.level,
          productValue
        )
      );
      const normalPrice = product?.variants?.map(
        (variant) => variant?.harga_normal
      );
      const promoFound = findOnePromo(product, promo);

      const priceStr = arrayToCurrencyString(price);
      const priceAfterPromoStr =
        promoFound &&
        arrayToCurrencyStringPromo(
          normalPrice,
          promoFound,
          level.level,
          global_komisi,
          productValue
        );

      const totalStock = product?.variants?.reduce((stock, curr) => {
        return stock + curr.stok_available;
      }, 0);

      const textBadgePromo = (() => {
        if (!promoFound) {
          return null;
        }

        if (promoFound?.tipe === "%") {
          return `${promoFound?.nilai}%`;
        }

        return `${promoFound?.nilai / 1000}K`;
      })();

      const lowestPrice = Math.round(Math.min(...normalPrice));
      const komisiValueStr = arrayToCurrencyStringKomisi(
        lowestPrice,
        level.level,
        promoFound,
        global_komisi,
        productValue
      );

      return {
        ...product,
        priceStr,
        priceAfterPromoStr,
        komisiValueStr,
        totalStock,
        textBadgePromo,
      };
    });
  }

  const result = [
    ...groupSort(
      populateProducts(products)?.sort(sortProducts("priceAfterPromoStr"))
    ),
  ];

  const Renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <>
        {days !== 0 ? (
          <div
            style={
              miniScreen
                ? {
                    backgroundColor: "rgb(86, 117, 211)",
                    borderRadius: "4px",
                    // display: "flex",
                    // marginLeft: "2px",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    paddingLeft: "3px",
                    paddingRight: "3px",
                  }
                : {
                    backgroundColor: "rgb(86, 117, 211)",
                    borderRadius: "4px",
                    // display: "flex",
                    // marginLeft: "2px",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                  }
            }
          >
            <Typography
              style={
                miniScreen
                  ? { fontWeight: "bold", fontSize: "10px" }
                  : { fontWeight: "bold", fontSize: "15px" }
              }
            >
              {days > 9 ? days : `0${days}`}
            </Typography>
            <Typography
              style={miniScreen ? { fontSize: "6px" } : { fontSize: "12px" }}
            >
              {" "}
              Hari
            </Typography>
          </div>
        ) : null}
        <div
          style={
            miniScreen
              ? {
                  backgroundColor: "rgb(86, 117, 211)",
                  borderRadius: "4px",
                  // display: "flex",
                  // marginLeft: "2px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "3px",
                  paddingRight: "3px",
                }
              : {
                  backgroundColor: "rgb(86, 117, 211)",
                  borderRadius: "4px",
                  // display: "flex",
                  // marginLeft: "2px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                }
          }
        >
          <Typography
            style={
              miniScreen
                ? { fontWeight: "bold", fontSize: "10px" }
                : { fontWeight: "bold", fontSize: "15px" }
            }
          >
            {hours > 9 ? hours : `0${hours}`}
          </Typography>
          <Typography
            style={miniScreen ? { fontSize: "6px" } : { fontSize: "12px" }}
          >
            {" "}
            Jam
          </Typography>
        </div>
        <div
          style={
            miniScreen
              ? {
                  backgroundColor: "rgb(86, 117, 211)",
                  borderRadius: "4px",
                  // display: "flex",
                  // marginLeft: "2px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "3px",
                  paddingRight: "3px",
                }
              : {
                  backgroundColor: "rgb(86, 117, 211)",
                  borderRadius: "4px",
                  // display: "flex",
                  // marginLeft: "2px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                }
          }
        >
          <Typography
            style={
              miniScreen
                ? { fontWeight: "bold", fontSize: "10px" }
                : { fontWeight: "bold", fontSize: "15px" }
            }
          >
            {minutes > 9 ? minutes : `0${minutes}`}
          </Typography>
          <Typography
            style={miniScreen ? { fontSize: "6px" } : { fontSize: "12px" }}
          >
            {" "}
            Menit
          </Typography>
        </div>
        <div
          style={
            miniScreen
              ? {
                  backgroundColor: "rgb(86, 117, 211)",
                  borderRadius: "4px",
                  // display: "flex",
                  // marginLeft: "2px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "3px",
                  paddingRight: "3px",
                }
              : {
                  backgroundColor: "rgb(86, 117, 211)",
                  borderRadius: "4px",
                  // display: "flex",
                  // marginLeft: "2px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                }
          }
        >
          <Typography
            style={
              miniScreen
                ? { fontWeight: "bold", fontSize: "10px" }
                : { fontWeight: "bold", fontSize: "15px" }
            }
          >
            {seconds > 9 ? seconds : `0${seconds}`}
          </Typography>
          <Typography
            style={miniScreen ? { fontSize: "6px" } : { fontSize: "12px" }}
          >
            {" "}
            Detik
          </Typography>
        </div>
      </>
    );
  };

  return !loading && products.length ? (
    <Paper
      elevation={0}
      // style={{ backgroundColor: "#5675D3" }}
      className={classes.container}
    >
      <Divider
        style={{
          height: 5,
          marginLeft: -10,
          marginRight: -10,
          backgroundColor: "#efefef",
        }}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 15,
          marginBottom: 7.5,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div>
            <Typography
              style={{
                fontSize: "13px",
                fontWeight: "bold",
                textTransform: "uppercase",
              }}
            >
              {mode}
            </Typography>
          </div>
          {/* <Countdown date={expiration_date} renderer={Renderer1} /> */}
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button
            size="small"
            endIcon={<ArrowRightIcon color="primary" />}
            onClick={() => setOpenFlashSale(true)}
          >
            <Typography color="primary" style={{ fontSize: "10px" }}>
              Lihat semua
            </Typography>
          </Button>
          <DialogFlashsale
            open={openFlashSale}
            handleClose={() => setOpenFlashSale(false)}
            data={result}
            keywords={keywords}
            timer={expiration_date}
            mode={mode}
          />
        </div>
      </div>
      <ScrollContainer className={classes.wrapScrollFlash}>
        <div className={classes.wrapper}>
          <div
            style={
              miniScreen
                ? {
                    backgroundColor: "#5675D3",
                    textAlign: "center",
                    marginTop: "45%",
                    padding: 10,
                  }
                : {
                    backgroundColor: "#5675D3",
                    textAlign: "center",
                    marginTop: "50%",
                    padding: 10,
                  }
            }
          >
            {mode === "Flashsale" ? (
              <img
                src={FlashSaleIcon}
                alt="icon"
                style={miniScreen ? { width: "100px" } : { width: "140px" }}
              />
            ) : mode === "Special Offers" ? (
              <img
                src={SpesialOfferIcon}
                alt="icon"
                style={miniScreen ? { width: "100px" } : { width: "140px" }}
              />
            ) : (
              ""
            )}
            <Typography
              style={
                miniScreen
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      color: "#FFF",
                      fontSize: "65%",
                    }
                  : {
                      display: "flex",
                      justifyContent: "center",
                      color: "#FFF",
                      fontSize: "100%",
                    }
              }
              component="p"
            >
              Berakhir dalam
            </Typography>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                color: "#FFF",
              }}
            >
              <Countdown date={expiration_date} renderer={Renderer} />
              {/* <Timer expiration_date={expiration_date} /> */}
            </div>
          </div>
        </div>

        {result.slice(0, 5).map((item) => {
          return (
            <div className={classes.wrapper} key={item.id}>
              <Card className={classes.card}>
                <CardActionArea onClick={toDetailProduct(item.id, item.nama)}>
                  {item?.textBadgePromo && (
                    <div className={classes.label}>
                      <Typography className={classes.txtLabel}>
                        {item.textBadgePromo}
                      </Typography>
                      <Typography className={classes.txtLabel}>OFF</Typography>
                    </div>
                  )}
                  {item.totalStock < 1 && (
                    <div className={classes.empty}>
                      <span className={classes.txtEmpty}>Stok Habis</span>
                    </div>
                  )}
                  {item.thumbnail?.length > 0 ? (
                    <div
                      loading="lazy"
                      className={classes.img}
                      style={{
                        backgroundImage: `url(${item?.thumbnail?.[0]})`,
                      }}
                    />
                  ) : (
                    <div
                      loading="lazy"
                      className={classes.img}
                      style={{
                        backgroundImage: `url(${item?.thumbnail?.[0]})`,
                      }}
                    />
                  )}
                </CardActionArea>
                <div className={classes.contentWrapperFlash}>
                  <div className={classes.contentFlash}>
                    <div style={{ display: "flex" }}>
                      <div className={classes.labelFlash}>{mode}</div>
                      {item?.properties?.type === "preorder" &&
                      item?.properties.end_at?.seconds * 1000 > Date.now() ? (
                        <div className={classes.labelPre}>Pre Order</div>
                      ) : null}
                    </div>{" "}
                    <Typography className={classes.title} component="p">
                      {item?.nama}
                    </Typography>
                    <Typography
                      className={classes.txtLabelharhag}
                      component="p"
                    >
                      Harga {upperFirst(level.level)}
                    </Typography>
                    <Typography className={classes.price} component="p">
                      {item.priceAfterPromoStr || item.priceStr}
                    </Typography>
                    <div className={classes.labelKomisi}>
                      {item.komisiValueStr} Komisi
                    </div>
                  </div>
                  <div className={classes.btnWrap}>
                    {item.totalStock < 1 ? (
                      <Button
                        fullWidth
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={classes.btn}
                        style={{
                          backgroundColor: "rgb(255, 107, 107)",
                        }}
                      >
                        Stok Habis
                      </Button>
                    ) : (
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        size="small"
                        className={classes.btn}
                        onClick={toDetailProduct(item?.id, item?.nama)}
                      >
                        Beli
                      </Button>
                    )}
                  </div>
                </div>
              </Card>
            </div>
          );
        })}

        {products?.length > 3 ? (
          <div
            style={{
              alignSelf: "center",
              paddingLeft: 37.5,
              paddingRight: 37.5,
            }}
            onClick={() => setOpenFlashSale(true)}
          >
            <div style={{ width: 80 }}>
              <PlayCircleOutlineIcon
                style={{ width: "100%", color: "white", fontSize: 27.5 }}
              />
              <Typography
                style={{ fontSize: 12.5, color: "white", marginTop: 10 }}
                align="center"
              >
                Lihat Semua
              </Typography>
            </div>
          </div>
        ) : null}
      </ScrollContainer>
    </Paper>
  ) : null;
}


function sortProducts(sortBy = "priceStr", sortDir = "asc") {
  return function (a, b) {
    const valueA = extractNumericValue(a[sortBy]);
    const valueB = extractNumericValue(b[sortBy]);

    let result = 0;
    if (valueA < valueB) {
      result = -1;
    } else if (valueA > valueB) {
      result = 1;
    }

    return sortDir === "desc" ? result * -1 : result;
  };
}

function groupSort(products) {
  const availableStocks = [];
  const emptyStocks = [];

  for (let i = 0; i < products.length - 1; i++) {
    if (products[i].totalStock > 0) {
      availableStocks.push(products[i]);
    } else {
      emptyStocks.push(products[i]);
    }
  }

  return [...availableStocks, ...emptyStocks];
}

function extractNumericValue(str) {
  const matches = str?.match(/\d+(\.\d+)?/g);
  return matches ? parseFloat(matches[0]) : 0;
}

export default FlashSale;
